import { useState } from 'react'
import 'react-international-phone/style.css'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import apiClient from 'src/Common/apiClient'

function useRegisterService() {
  const [formData, setFormData] = useState({
    studentEmail: '',
    studentFirstName: '',
    studentLastName: '',
    parentFirstName: '',
    parentLastName: '',
    parentEmail: '',
  })
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)

  const [formDataError, setFormDataError] = useState({
    studentEmailError: '',
    studentFirstNameError: '',
    studentLastNameError: '',
    parentFirstNameError: '',
    parentLastNameError: '',
    parentEmailError: '',
  })

  // Batch-07: registration no longer takes a password (the user sets it later via the
  // emailed set-password link). Parent names are required only when the parent is new,
  // which the FE can't know — so they're optional here and the backend re-flags via
  // PARENT_NAME_REQUIRED.
  const OPTIONAL_FIELDS = ['parentFirstName', 'parentLastName']

  const handleChange = (e) => {
    if (!e || !e.target) {
      console.error('Event or target is undefined:', e)
      return
    }

    const { name, value } = e.target
    // Clear the error message for the field being edited
    setFormDataError({ ...formDataError, [`${name}Error`]: '' })
    // setFormDataError({ ...formDataError, studentMobileNumberError: '' })
    setFormData({ ...formData, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      setIsLoading(true) // Set loading state to true
      let hasError = false

      // Required-field check (parent names are optional — see OPTIONAL_FIELDS)
      Object.keys(formData).forEach((fieldName) => {
        if (OPTIONAL_FIELDS.includes(fieldName)) return
        if (typeof formData[fieldName] === 'string' && !formData[fieldName].trim()) {
          const fieldNameWithSpaces = fieldName
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, (str) => str.toUpperCase())
          setFormDataError((prevState) => ({
            ...prevState,
            [`${fieldName}Error`]: `${fieldNameWithSpaces} is required.`,
          }))
          hasError = true
        }
      })

      // Check if parent and student emails are the same
      if (
        formData.studentEmail &&
        formData.parentEmail &&
        formData.studentEmail === formData.parentEmail
      ) {
        toast.error('Parent and student emails cannot be the same.', {
          autoClose: 5000,
          style: { background: 'lightcoral', color: 'white' },
        })
        setIsLoading(false)
        return
      }

      if (hasError) {
        console.log('Validation errors detected')
        setIsLoading(false)
        return
      }
      // Batch-07: no password in the register payload.
      const response = await apiClient.post('/Account/Student-Register', formData, {
        headers: {
          'Content-Type': 'application/json',
        },
      })

      const responseData = response.data
      sessionStorage.setItem('studentRegistrationConfirmation', JSON.stringify(responseData))
      navigate('/emailConfirmation', { state: responseData })
    } catch (error) {
      const code = error?.response?.rawData?.code || error?.response?.data?.code
      if (code === 'PARENT_NAME_REQUIRED') {
        setFormDataError((prevState) => ({
          ...prevState,
          parentFirstNameError: 'Required for a new parent account.',
          parentLastNameError: 'Required for a new parent account.',
        }))
      }
    } finally {
      setIsLoading(false)
    }
  }

  return { formData, formDataError, isLoading, handleSubmit, handleChange }
}

export default useRegisterService
